import React from 'react';
import TwoSidedDocumentUploadScreen from './TwoSidedDocumentUploadScreen';

export default function TechnicalInspectionDocumentUploadScreen(props) {
  return (
    <TwoSidedDocumentUploadScreen
      {...props}
      routeName="technical_inspection_doc_upload"
      previousRoute="transport_licence_doc_upload"
      nextRoute="insurance_doc_upload"
      docType="TECHNICAL_INSPECTION"
      docKey="technicalInspection"
      skipFlag="technicalInspectionSkipped"
      title="Visite technique taxi"
      subtitle="Ajoutez le recto et le verso de la visite technique, ou importez un PDF complet."
    />
  );
}